"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";

interface MenuItemWithSvgProps {
  svgFileName: string; // SVG 文件名，例如 "Frame-1.svg"
  title: string;
  className?: string;
  link?: string;
}

export const MenuItemWithSvg: React.FC<MenuItemWithSvgProps> = ({
  svgFileName,
  title,
  className = "",
  link = "",
}) => {
  const [svgContent, setSvgContent] = useState<string>("");
  const router = useRouter();

  useEffect(() => {
    // 动态加载 SVG 文件内容
    fetch(`/imgs/nav/${svgFileName}`)
      .then((res) => res.text())
      .then((text) => {
        console.log(">>>>>>>.text", text);
        setSvgContent(text);
      })
      .catch((err) => {
        console.error(`Failed to load SVG: ${svgFileName}`, err);
      });
  }, [svgFileName]);

  const content = (
    <>
      {svgContent && (
        <div
          className="w-[20px] h-[20px] flex-shrink-0 [&_svg]:w-full [&_svg]:h-full [&_path]:transition-colors [&_path]:duration-200  [&_path]:fill-[#1677FF]"
          dangerouslySetInnerHTML={{ __html: svgContent }}
        />
      )}
      <span className="text-[#333333] transition-colors duration-200 group-hover:text-[#1677FF]">
        {title}
      </span>
    </>
  );

  // 处理解决方案页面的特殊链接（不显示锚点）
  const handleSolutionsLink = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (link && link.startsWith("/solutions#")) {
      e.preventDefault();
      const hash = link.split("#")[1];
      // 将锚点信息存储到 sessionStorage
      sessionStorage.setItem("solutionsScrollTarget", hash);

      // 如果已经在 solutions 页面，直接触发滚动（不依赖路由重载）
      if (typeof window !== "undefined" && window.location.pathname === "/solutions") {
        window.dispatchEvent(new Event("solutions-scroll"));
        return;
      }

      // 导航到不带锚点的路径
      router.push("/solutions");
    }
  };

  if (link) {
    // 如果是解决方案页面的链接，使用自定义处理
    if (link.startsWith("/solutions#")) {
      return (
        <a
          href="/solutions"
          onClick={handleSolutionsLink}
          className={`my-[10px]  font-regular text-[17px] text-[#333333] group cursor-pointer transition-colors duration-200 hover:text-[#1677FF] flex items-center gap-2 ${className}`}
        >
          {content}
        </a>
      );
    }

    return (
      <Link
        href={link}

        className={`my-[10px]    font-regular text-[17px] text-[#333333] group cursor-pointer transition-colors duration-200 hover:text-[#1677FF] flex items-center gap-2 ${className}`}
      >
        {content}
      </Link>
    );
  }

  return (
    <div
      className={`my-[10px]  font-regular text-[17px] text-[#333333] group cursor-pointer transition-colors duration-200 hover:text-[#1677FF] flex items-center gap-2 ${className}`}
    >
      {content}
    </div>
  );
};
